import styled from 'styled-components'

export const Heading = styled.h1`
    font-size: 2.2rem;
    font-weight: bold;
    color: #222;
`;